import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { throttleTime, tap } from 'rxjs/operators';

@Directive({
    selector: '[appPreventDoubleClick]',
    standalone: false
})
export class PreventDoubleClickDirective implements OnInit, OnDestroy {

	@Input() throttleTime: number = 500;
	@Output() throttledClick: EventEmitter<any> = new EventEmitter<any>();

	private clicks: Subject<any> = new Subject<any>();
	private subscription: Subscription = new Subscription();

	constructor() { }


	ngOnInit() {
		this.subscription = this.clicks.pipe(
			tap(() => { console.log('read click event'); }),
			throttleTime(this.throttleTime)
		).subscribe(
			(e) => {
				console.log('emitting click event');
				this.emitThrottledClick(e);
			});
	
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	emitThrottledClick(e) {
		this.throttledClick.emit(e);
	}

	@HostListener('click', ['$event'])
	clickEvent(event) {
		console.log('read click event')
		event.preventDefault();
		event.stopPropagation();
		this.clicks.next(event);
	}

}
